// Where "Switch to normal view" sends the user (the original dark portal).
//
// In production "/old/portal" is a Vercel rewrite (see vercel.json) to the
// original portal deployment. That rewrite does NOT exist on the CRA dev
// server, so to test the switch locally point this at the deployed old portal
// in .env.local:
//   REACT_APP_OLD_PORTAL_URL=https://jurident-old.vercel.app/old/portal
export const OLD_PORTAL_URL =
  process.env.REACT_APP_OLD_PORTAL_URL || "/old/portal";
